import React from 'react';
import config from '../../../utils/config';

function CustomExportArevian() {
	return (
		<div id="main-container" className="main-container nav-effect-1">
			<iframe
				style={{ top: '0px' }}
				id="ouilink-iframe"
				src={`${config.reportingV4Url}custom-export-arevian${window.location.search}`}
			/>
		</div>
	);
}
export default CustomExportArevian;
